// Compresse une image côté navigateur avant l'envoi vers Google Drive :
// les photos prises avec un téléphone pèsent souvent 3 à 6 Mo, on les ramène
// à environ 200-300 Ko (1 280 px de large), ce qui accélère beaucoup l'envoi.
//
// On utilise createImageBitmap quand le navigateur le permet : le décodage et
// le redimensionnement se font alors sans bloquer la page, bien plus vite
// qu'avec la méthode classique (FileReader + <img>), surtout sur téléphone.

function versBlob(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("Échec de la compression de l'image"))),
      "image/jpeg",
      quality
    );
  });
}

function chargerImageClassique(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Image illisible")); };
    img.src = url;
  });
}

/**
 * @param {File} file - fichier image d'origine
 * @param {number} maxWidth - plus grand côté maximal en pixels
 * @param {number} quality - qualité JPEG (0 à 1)
 * @returns {Promise<Blob>} image compressée
 */
export async function compressImage(file, maxWidth = 1280, quality = 0.72) {
  if (!file.type || !file.type.startsWith("image/")) return file; // PDF : tel quel

  let source, largeur, hauteur;
  try {
    if (typeof createImageBitmap === "function") {
      source = await createImageBitmap(file, { imageOrientation: "from-image" });
    } else {
      source = await chargerImageClassique(file);
    }
  } catch (e) {
    source = await chargerImageClassique(file);
  }
  largeur = source.width;
  hauteur = source.height;

  const echelle = Math.min(1, maxWidth / Math.max(largeur, hauteur));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(largeur * echelle);
  canvas.height = Math.round(hauteur * echelle);
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
  if (source.close) source.close();

  const blob = await versBlob(canvas, quality);
  // Si la "compression" grossit le fichier (image déjà petite), on garde l'original.
  return blob.size < file.size || file.type !== "image/jpeg" ? blob : file;
}
